import React, { useState } from "react";
import { setTitle } from "../../../helpers/MetaTag";
import ProfileStatistics from "../../../components/sections/front/User/ProfileStatistics";
import CurrentSubscription from "../../../components/sections/front/User/CurrentSubscription";
import CurrentAddress from "../../../components/sections/front/User/CurrentAddress";
import AddressList from "../../../components/sections/front/User/AddressList";
import Modal from "../../../components/elements/Modal";
import ManageAddressModalContent from "../../../components/sections/front/User/ManageAddressModalContent";
import useFetch from "../../../hooks/useFetch";
import {
  addressDelete,
  addressStatusChange,
  getaddressList,
} from "../../../services/addressService";
import useMutation from "../../../hooks/useMutation";
import DeleteModal from "../../../components/common/DeleteModal";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { setDefaultAddressSidebar } from "../../../redux/slice/profileSlice";
const ManageAddress = () => {
  setTitle("Memory Doddle | Address");
  // const [addModalOpen, setAddModalOpen] = useState(false);
  const [modalOpen, setModalOpen] = useState({ isOpen: false, data: null });
  const [deleteModal, setDeleteModal] = useState({ isOpen: false, data: null });
  const defaultAddressSidebar = useSelector(
    (state) => state.profile.defaultAddress
  );
  const dispatch = useDispatch();
  const {
    data: addresses = [],

    isLoading,
    updateData,

    refetch,
    error,
  } = useFetch({
    dependencies: ["addressList"],

    fetchFunction: async () => {
      const res = await getaddressList();

      if (res?.status === 200 && Array.isArray(res?.data)) {
        // return res.data.map((item) => ({
        //   _id: item._id,

        //   name: item.name || `${item.firstName} ${item.lastName}`,

        //   addressLine1: `${item.address1}`,

        //   addressLine2: `${item.address2}`,

        //   phone: item.phone || "",

        //   email: item.email || "",

        //   isDefault: item.isDefault,

        //   addressType: item.label || "Other",
        // }));

        const transformed = res.data.map(transformAddress);
        const defaultAddr = transformed.find((addr) => addr.isDefault);
        // setDefaultAddressSidebar(defaultAddr);
        dispatch(setDefaultAddressSidebar(defaultAddr));
        return transformed;
      }

      return [];
    },
  });
  const transformAddress = (item) => ({
    _id: item._id,
    name: item.name || `${item.firstName} ${item.lastName}`,
    addressLine1: `${item.address1}`,
    addressLine2: `${item.address2}`,
    phone: item.phone || "",
    email: item.email || "",
    isDefault: item.isDefault,
    addressType: item.label || "Other",
  });

  //  const addressManageResponse = (res) => {
  //     const rawData = Array.isArray(res?.data) ? res.data[0] : res.data;
  //     if (!rawData) return;

  //     const formatted = transformAddress(rawData);

  //     if (res?.status === 201) {
  //       updateData((prev) => [formatted, ...(Array.isArray(prev) ? prev : [])]);
  //     }

  //     if (res?.status === 200) {
  //       updateData((prev) =>
  //         (Array.isArray(prev) ? prev : []).map((item) =>
  //           item._id === formatted._id ? formatted : item
  //         )
  //       );
  //     }

  //     setModalOpen({ isOpen: false, data: null });
  //   };

  const addressManageResponse = (res) => {
    let rawData = res?.data;

    if (Array.isArray(rawData)) {
      const targetId = modalOpen?.data?._id;

      if (targetId) {
        rawData = rawData.find((item) => item._id === targetId);
      } else {
        rawData = rawData.find(
          (item) => !addresses.some((addr) => addr._id === item._id)
        );
      }
    }

    if (!rawData) return;

    const formatted = transformAddress(rawData);

    if (res?.status === 201) {
      updateData((prev) =>
        [formatted, ...(Array.isArray(prev) ? prev : [])].map((item) => ({
          ...item,
          isDefault: item._id === formatted._id ? formatted.isDefault : false,
        }))
      );
      if (formatted.isDefault) {
        dispatch(setDefaultAddressSidebar(formatted));
      }
      refetch();
      setModalOpen({ isOpen: false, data: null });
      return;
    }

    if (res?.status === 200) {
      updateData((prev) =>
        (Array.isArray(prev) ? prev : []).map((item) => {
          if (item._id === formatted._id) return formatted;
          if (formatted.isDefault) return { ...item, isDefault: false };
          return item;
        })
      );
      if (formatted.isDefault) {
        dispatch(setDefaultAddressSidebar(formatted));
      }
    }
    refetch();
    setModalOpen({ isOpen: false, data: null });
  };

  // delete address
  const { mutate: deleteHandler, isPending: deletePending } = useMutation({
    mutationFn: async (id) => {
      const res = await addressDelete({ addressId: id });
      return { res, id };
    },
    onSuccess: ({ res, id }) => {
      if (res?.status === 200) {
        setDeleteModal({ isOpen: false, data: null });
        updateData((pre) =>
          (Array.isArray(pre) ? pre : []).filter((item) => item._id !== id)
        );
      }
    },
    onError: (error) => {
      console.error("Delete failed:", error);
    },
  });

  //status change handler
  const { mutate: setDefaultAddress } = useMutation({
    mutationFn: async (id) => {
      const res = await addressStatusChange({ addressId: id });
      return { res, id };
    },

    onSuccess: ({ res, id }) => {
      if (res?.status === 200) {
        updateData((prev) =>
          (Array.isArray(prev) ? prev : []).map((item) => {
            const updated = {
              ...item,
              isDefault: item._id === id,
            };
            if (updated.isDefault) dispatch(setDefaultAddressSidebar(updated));

            return updated;
          })
        );
      }
    },

    onError: (err) => {
      console.error("Set default failed:", err);
    },
  });
  // console.log(defaultAddressSidebar);
  return (
    <>
      <div className="relative space-y-5">
        <div className="grid grid-cols-3 gap-4 3xl:gap-6 items-start">
          <div className="relative col-span-2">
            <AddressList
              title={"Saved Address"}
              data={addresses}
              // setAddresses={() => {}} // optional if internal update needed
              // setAddModalOpen={setAddModalOpen}
              // setAddModalOpen={() => setModalOpen({ isOpen: true, data: null })}
              setAddModalOpen={(item = null) =>
                setModalOpen({ isOpen: true, data: item })
              }
              isLoading={isLoading}
              setDeleteModal={setDeleteModal}
              onSetDefault={setDefaultAddress}
            />
          </div>
          <div className="relative grid grid-cols-1 gap-4">
            <ProfileStatistics />
            <CurrentSubscription />
            <CurrentAddress address={defaultAddressSidebar} />
          </div>
        </div>
      </div>
      <Modal
        title={"Add / Modify Address"}
        size="xl"
        // isOpen={addModalOpen}
        // setIsOpen={() => setAddModalOpen(false)}
        isOpen={modalOpen.isOpen}
        setIsOpen={() => setModalOpen({ isOpen: false, data: null })}
        titleClass={""}
        headerClass={"!bg-black !rounded-t-lg !text-white"}
        childrenClasses={"!rounded-b-lg"}
      >
        {console.log(modalOpen, "mdd")}
        <ManageAddressModalContent
          addressData={modalOpen.data}
          setAddModalOpen={(val) => setModalOpen({ isOpen: val, data: null })}
          onSuccess={addressManageResponse}
          //  setAddModalOpen={setAddModalOpen}
        />
      </Modal>
      <DeleteModal
        open={deleteModal?.isOpen}
        loading={deletePending}
        onClose={() => setDeleteModal({ data: null, isOpen: false })}
        deleteHandler={() => {
          deleteHandler(deleteModal?.data?._id);
        }}
      />
    </>
  );
};

export default ManageAddress;
